import { getQuestionList, saveQuestion, updateQuestion } from 'actions/Catalogs';
import Loader from 'components/UI/Loader';
import React, { useEffect, useState } from 'react'
import { IoCloseCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { setQuestionById } from 'redux/catalog.slice';
import { notify } from 'utils';

const ModalHeader = ({ title, onClose }) => (
  <div className='h-20 w-full flex flex-row justify-between items-center px-5 bg-black rounded-t-lg'>
    <span className="text-white font-[Gravity] text-2xl font-bold">
      {title}
    </span>
    <IoCloseCircleOutline onClick={onClose} className='text-white text-4xl cursor-pointer' />
  </div>
)

const ModalCreateQuestion = ({ isOpen, onClose }) => {
  const [showModal, setShowModal] = useState(false);
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { questionByIdList } = useSelector((state) => state.catalog);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setShowModal(true), 10);
    } else {
      setShowModal(false);
    }
  }, [isOpen]);

  const validations = () => {
    if (description.trim() === '') {
      notify("error", "Por favor, ingrese la descripción de la pregunta", 1200);
      return false;
    }

    return true;
  }

  const handleClose = () => {
    onClose();
  };

  const saveResponse = async () => {
    const { id = 0 } = questionByIdList || {};
    if (!validations()) return;
    setIsLoading(true);

    try {
      let payload = {
        "description": description,
      };

      if (id > 0) {
        payload.active = +status === 1 ? true : false;
        await dispatch(updateQuestion({ ...payload, id }));
      } else {
        await dispatch(saveQuestion(payload));
      }
      await dispatch(getQuestionList());
      handleClose();
    } catch (error) {
      console.error("Error al guardar la pregunta:", error);
      notify("error", "Hubo un problema al guardar", 2000);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (isOpen && questionByIdList && Object.keys(questionByIdList).length > 0) {
      const { description = '', active = true } = questionByIdList;
      setDescription(description);
      setStatus(active === true ? 1 : 0)
    }
  }, [isOpen, questionByIdList]);

  useEffect(() => {
    if (!isOpen) {
      setDescription('');
      if (questionByIdList && Object.keys(questionByIdList).length > 0) {
        dispatch(setQuestionById({}));
      }
    }
  }, [isOpen, dispatch, questionByIdList]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <Loader />
      </div>
    );
  }

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className={`bg-white max-h-[90vh] overflow-y-auto rounded-xl shadow-lg w-[90vw] max-w-3xl relative transition-all duration-300 transform ${showModal ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        <ModalHeader title={'Guardar Pregunta'} onClose={handleClose} />

        <div className='w-full h-[85%] p-5 flex flex-col'>
          <label className='text-black font-bold py-2'>Pregunta:</label>
          <textarea className='h-16 w-full lg:h-40 bg-gray-300 rounded-lg p-2' value={description} onChange={(e) => setDescription(e.target.value)} />

          {
            questionByIdList?.id && (
              <>
                <label className='text-black font-bold py-2'>Estatus:</label>
                <select className='border-2 border-gray-400 h-9 rounded-lg' value={status} onChange={({target})=> setStatus(target.value)}>
                  <option value={1}>Activo</option>
                  <option value={0}>Inactivo</option>
                </select>
              </>
            )
          }

          <div className='w-full mt-auto flex justify-end gap-2 pt-4'>
            <div className='h-10 w-32 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]' onClick={handleClose}>Cancelar</div>
            <div className='h-10 w-32 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]' onClick={saveResponse}>Guardar</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCreateQuestion